<template>
  <div class="container-fluid">
    <div class="row justify-content-center py-3 align-items-center">
      <div class="mt-2 qrText">SCAN QR CODE TO PAY</div>
      <div
        class="w-100 d-flex align-items-center justify-content-center"
        v-if="qrData"
      >
        <img
          :src="qrData"
          height="200"
          width="200"
          class="mx-auto d-block mt-2"
        />
      </div>

      <div class="mt-2 qrText" v-if="amount"
        >{{ amount }}&nbsp;{{ curr_code }}
        <img
          v-if="QfxClient"
          src="@/assets/img/FonepayPrimary.png"
          class="mx-auto d-block mt-2 partnerImg"
        />
        <p class="mb-2" v-if="QfxClient">Preferred Payment Partner</p>
        <img
          v-if="QfxClient"
          src="@/assets/img/Khalti_Logo_Color.png"
          class="mx-auto d-block mt-2 partnerImg"
        />
      </div>
    </div>
  </div>
</template>
<script>
  import { CLIENT_NAME } from "@/helper/Role";
  export default {
    props: {
      curr_code: String,
      amount: String,
      qrData: {
        type: String,
        default: "",
      },
    },
    computed: {
      QfxClient() {
        let clientData = this.secureStore.get("CLIENT_SETUP_NAME");
        return CLIENT_NAME.QFX == clientData;
      },
    },
    methods: {},
  };
</script>

<style>
  .qrText {
    font-size: 20px;
    color: black;
    font-weight: bolder;
    text-align: center;
  }
  .partnerImg {
    width: 100px;
  }
</style>
